import React from 'react';
import { HashRouter, Routes, Route } from 'react-router';
import 'whatwg-fetch';
import App from './app/App';
import { Auth0Provider } from '@auth0/auth0-react';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { SnackbarProvider } from './snackbarContext/SnackbarContext';
import config from './config';
import { DialogProvider } from './dialogContext/DialogContext';
import SurveyView from './survey/SurveyView';
import { createRoot } from 'react-dom/client';

const { AUTH0_DOMAIN: domain, AUTH0_CLIENT_ID: clientId, AUTH0_AUDIENCE: audience, AUTH0_SCOPE: scope } = config;

const jsx = (
  <SnackbarProvider>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        'redirect_uri': window.location.origin,
        audience,
        scope
      }}
    >
      <DialogProvider>
        <HashRouter>
          <Routes>
            <Route path="/surveys/:id/:verifierId/:logId?/:contactId?" element={<SurveyView />} />
            <Route path="*" element={<App />} />
          </Routes>
        </HashRouter>
      </DialogProvider>
    </Auth0Provider>
  </SnackbarProvider>
);

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(jsx);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
